<!-- <input matInput type="text" style="border: none; box-sizing: border-box" [(ngModel)]="hdn" appAutowidth> -->
<mat-button-toggle-group [value]="selectedType" style="margin: 5px;">
    <mat-button-toggle *ngFor="let field of formConfigjson" (change)="showNext(field)" [value]="field.value">
        <!-- <i *ngIf="field.connstatus!='notdone'" class="fa-solid fa-database fa-lg" [ngClass]="{'success-icon': field.connstatus == 'success',
        'error-icon': field.connstatus == 'error',
        'warning-icon': field.connstatus == 'warning'}" style="margin-top: -3px;"></i> -->
        <ng-container *ngIf="getIconImageSrc(field); else cssIcon">
          <img [src]="getIconImageSrc(field)"
               style="width:16px; height:16px; vertical-align:middle; margin-right:5px;" />
        </ng-container>
        <ng-template #cssIcon>
          <i *ngIf="field.connstatus!='notdone'"
             [ngClass]="[getIconClass(field), getStatusClass(field.connstatus)]"
             style="margin-right: 5px;"></i>
        </ng-template>
        {{ field.label }}
    </mat-button-toggle>
</mat-button-toggle-group>
<mat-slide-toggle style="margin-left: 10px;margin-right:10px;" labelPosition="before" color="primary" [checked]="isRunWriter" (change)="toggleRunWriter($event)">Run Writer</mat-slide-toggle>
<button mat-raised-button color="primary" (click)="testWriter()" style="margin-right: 10px;margin-left:-20px;">Write Data Now</button>
<button mat-raised-button color="primary" (click)="saveConfig()" style="margin-right: 2px;">Save Config</button><br>
<div style="margin-top: 5px;margin-bottom: 10px;">
    <button mat-raised-button color="primary" (click)="exportDataWriter()" style="margin-right: 5px;margin-left: 6px;margin-top: 1px;">Export Data Writer</button>
    <input type="file" id="fileInput" (change)="importDataWriter($event)" accept=".json" onclick="this.value = null" style="display: none;">
    <button mat-raised-button color="primary" (click)="triggerFileInput()" style="margin-right: 4px;margin-left: 6px;margin-top: 1px;">Import Data Writer</button>

    <!-- Hardcoded Status Panel -->
 <!-- Status Panel: Visible Only When ShowStatusPanel is True -->
 <div *ngIf="showStatusPanel && isdbmapping" style="margin-left: 15px; padding: 5px 10px; background-color: #1e1e1e; 
 color: #00ff00; font-weight: normal; border: 1px solid #00ff00; 
 border-radius: 5px; display: inline-block;">
✅ Data write complete. Updated: <b>{{ updatedRows }}</b>, Inserted: <b>{{ insertedRows }}</b>
</div>
</div>
<div *ngIf="isShowedForm">
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- <input type="hidden" [formControlName]="hdn" > -->
    <p style="margin-top: 0px;margin-left: 5px;" *ngIf="formConfigjsonNextButton.length > 0">
        <mat-button-toggle-group [value]="selectedSubType">
            <mat-button-toggle *ngFor="let field of formConfigjsonNextButton" 
                               (change)="bindJsonFormNext(field)" 
                               [value]="field.value">
                <span style="display: flex; align-items: center; gap: 5px;">
                    <i *ngIf="field.connstatus === 'success'" 
                       class="fa-solid fa-check" 
                       [ngClass]="'success-icon'">
                    </i>
                    <i *ngIf="field.connstatus === 'error'" 
                       class="fa-solid fa-times" 
                       [ngClass]="'error-icon'">
                    </i>
                    {{ field.label }}
                </span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </p>
    
    <!-- Use FTP (file writers only), as in ingest: the Export Directory below is then a folder on the selected SFTP service. -->
    <div *ngIf="isFtpUploadWriter && dwFtp" class="dw-ftp-section">
        <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="dwFtp.useFtp" [ngModelOptions]="{standalone: true}" (change)="onUseFtpToggled()">Use FTP</mat-slide-toggle>
        <div *ngIf="dwFtp.useFtp">
            <app-ftp-service-select [loadConfiguration]="false" [selectedServiceId]="dwFtp.ftpServiceId"
                (selectedServiceIdChange)="onFtpServiceSelected($event)"
                (connectionStatusChange)="ftpConnectionStatus = $event"></app-ftp-service-select>
        </div>
    </div>
    <div style=" margin-left: 5px; margin-top: 0px;margin-top: 12px;">
    <ng-container *ngFor="let field of formConfigjsonNext">
          <ng-container *ngIf="(+field.ukey < 10) ||  ((+field.ukey > 10) && (selectedType === 'database'))"  >
        <ng-container [ngSwitch]="field.type">
            <mat-form-field *ngIf="field.type!='button' && field.type!='label'" appearance="outline" style="margin-right: 5px;" [style.width]="field.width" [class.select-disabled]="field.ukey == '3' && isDisabled">
                <mat-label>{{ field.ukey == '1' && isFtpUploadWriter && dwFtp?.useFtp ? field.label + ' (SFTP)' : field.label }}</mat-label>
                <input matInput *ngSwitchCase="'input'" type="text" [formControlName]="field.name" 
                [attr.autocomplete]="field.autocomplete || 'off'"
                [attr.autocorrect]="'off'"
                (input)="updateFileName(form.controls[field.name].value,'')"
                [attr.autocapitalize]="'off'"
                [attr.spellcheck]="'false'">
                <input matInput *ngSwitchCase="'number'" type="number" [formControlName]="field.name">
                <input matInput *ngSwitchCase="'password'" type="password" [formControlName]="field.name"   [attr.autocomplete]="field.autocomplete || 'off'"
                [attr.autocorrect]="'off'"
                [attr.autocapitalize]="'off'"
                [attr.spellcheck]="'false'">
                <input matInput *ngSwitchCase="'email'" type="email" [formControlName]="field.name">
                <input matInput *ngSwitchCase="'search'" type="search" [formControlName]="field.name">
                <input matInput *ngSwitchCase="'tel'" type="tel" [formControlName]="field.name">
                <input matInput *ngSwitchCase="'url'" type="url" [formControlName]="field.name">
                <textarea matInput *ngSwitchCase="'textarea'" [formControlName]="field.name"></textarea>
                <mat-select *ngSwitchCase="'select'" [formControlName]="field.name" (selectionChange)="(field.ukey == '3' || field.ukey == '4') && onExtensionChange($event)" [disabled]="field.ukey == '3' && isDisabled">
                    <mat-select-trigger>
                      <span [class.trigger-disabled]="field.ukey == '3' && isDisabled">{{ getSelectedOptionText(field) }}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.text }}</mat-option>
                </mat-select>

                <input matInput *ngSwitchCase="'file'" type="text" [formControlName]="field.name">
                <button mat-icon-button matSuffix *ngSwitchCase="'file'" (click)="browseDir(field.name)">
                    <mat-icon *ngSwitchCase="'file'" matSuffix color="primary" style="height: 100%;line-height: 16px;top: 5px;">folder</mat-icon>
                </button>

                <mat-select *ngSwitchCase="'selectdynamic'" [formControlName]="field.name" [disabled]="field.ukey == '0' && isDisabled">
                    <mat-select-trigger>
                      <span [class.trigger-disabled]="field.ukey == '0' && isDisabled">{{ getSelectedOptionText(field) }}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of selectdynamicsource" [value]="option.value">
                    {{ option.text }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- <span *ngSwitchCase="'label'" readonly [formControlName]="field.name">{{ field.value }}</span> -->
        </ng-container>
        </ng-container>
    </ng-container>


    <button type="button" mat-raised-button color="primary" (click)="testConnection()" style="margin-left: 5px; margin-top: 0px;margin-bottom: 2px;">  {{ isdbmapping ? 'Connect to Database' : 'Test Connection' }}</button>
    <ng-container *ngFor="let field of formConfigjsonNext">
        <ng-container [ngSwitch]="field.type">
            <div *ngSwitchCase="'label'" readonly  style="margin-left: 0px;margin-top: 3px;margin-bottom: 3px;">{{ field.value }}</div>
        </ng-container>
    </ng-container>
  </div>
        <!-- new row starts here -->
<!-- new row starts here -->
<div style="margin-top: 10px; display: flex; gap: 3px; align-items: center;margin-left: 4px;margin-bottom: -10px;" *ngIf="selectedType === 'parquet'">
  <ng-container *ngFor="let field of formConfigjsonNext">
    <ng-container *ngIf="field.ukey && +field.ukey >= 10">   <!-- ✅ numeric check -->
      <ng-container [ngSwitch]="field.type">
        <mat-form-field *ngSwitchCase="'number'" appearance="outline" style="margin-right: 5px;" [style.width]="field.width">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput type="number" min="1" max="11" [formControlName]="field.name" (input)="onNumberFieldChange(field, $event)">
        </mat-form-field>
        <!-- Select -->
        <mat-form-field *ngSwitchCase="'select'" appearance="outline" [style.width]="field.width"  style="margin-right: 5px;">
          <mat-label>{{ field.label }}</mat-label>
          <mat-select [formControlName]="field.name" (selectionChange)="onSelectFieldChange(field, $event.value)">
            <mat-option *ngFor="let option of field.options" [value]="option.value">
              {{ option.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        
  <!-- Select -->
     
  <mat-form-field *ngSwitchCase="'multiselect'" appearance="outline" [style.width]="field.width"  style="margin-right: 5px;">
  <mat-label>{{ field.label }}</mat-label>
  <mat-select [formControlName]="field.name" (selectionChange)="onPartitionColumnSelectionChange($event.value)">
    <mat-option *ngFor="let option of partitionColumnOptions" [value]="option.value">
      {{ option.text }}

    </mat-option>
  </mat-select>
</mat-form-field>



          <!-- Toggle -->
        <mat-slide-toggle *ngSwitchCase="'toggle'" [formControlName]="field.name" color="primary">
          {{ field.label }}
        </mat-slide-toggle>

        <!-- Label -->
        <span *ngSwitchCase="'label'" readonly style="margin-left: 10px;">
          {{ field.value }}
        </span>

      </ng-container>
    </ng-container>
  </ng-container>
</div>

</form>
<div style="display: flex; align-items: center; gap: 3px; margin-top:8px;margin-left: 5px;margin-bottom: 10px;">
    <!-- Table Name Dropdown -->
    <mat-form-field *ngIf="isdbmapping" style="flex-shrink: 0; min-width: 200px;margin-right: 5px;" appearance="outline" >
        <mat-label>Table Name</mat-label>
        <mat-select (selectionChange)="onSelectionChange($event)" [ngModel]="selectedtable">
            <mat-option *ngFor="let col of targettables" [value]="col.value">
                {{ col.text }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="isdbmapping" style="flex-shrink: 0; min-width: 200px;margin-right: 5px;" appearance="outline">
        <mat-label>Primary Key</mat-label>
        <input matInput [(ngModel)]="primarykeyvalue" placeholder="Primary Key" [disabled]="true">
    </mat-form-field>
    
<!-- Field Chooser (Display Selected Fields) -->
<div style="cursor: pointer; margin-top: -4px; position: relative; display: inline-flex; 
            align-items: center; border: 0.5px solid grey; padding: 8px 8px; 
            border-radius: 6px; font-size: 12px; font-weight: bold; font-family: sans-serif; 
            white-space: pre; height: 32px; min-width: 200px; background-color: black; 
            box-sizing: border-box;" 
     (click)="onKeyFieldSelectCellClicked()" *ngIf="isdbmapping">

    <!-- Floating Label "Key Fields" (Same Style as "Table Name") -->
    <span style="position: absolute; top: -5px; left: 8px; background-color: black; 
                 color: #b8b8b8; font-size: 11px; font-weight: bold; font-family: sans-serif; 
                 padding: 0 5px;">
       Additional Key Fields
    </span>

    <span *ngIf="selectedColumns?.length > 0; else emptyText">
        <span *ngFor="let col of selectedColumns" 
              [style.color]="getColor(col)" 
              style="margin-right: 5px; white-space: pre; font-size: 12px; font-weight: bold; 
                     font-family: sans-serif; color: white;">
            {{ col?.text }}
        </span>
    </span>

    <!-- Show "Select the key fields" if no value is selected -->
    <ng-template #emptyText>
        <span style="color: orange; font-size: 12px; font-weight: bold; font-family: sans-serif; 
                     white-space: pre;">
           Select Additional Key Fields
        </span>
    </ng-template>
</div>

</div>
<div style="margin-bottom: -8px;margin-top: 4px;">
<button mat-raised-button color="primary"  style="margin-right: 10px;margin-left: 4px;margin-top: -5px;" *ngIf="isdbmapping" (click)="runAutoMapper()">Run Auto Mapper</button>
<button mat-raised-button color="primary"  style="margin-right: 10px;margin-top: -5px;" *ngIf="isdbmapping" (click)="matchToPreviousMapping()">Find Previous Mapping</button>
<button mat-raised-button color="primary"  style="margin-right: 10px;margin-top: -5px;" *ngIf="isdbmapping" (click)="clearMap()">Clear Map</button>
</div>
<table mat-table (cdkDropListDropped)="dropExportColumnTable($event)" cdkDropList [dataSource]="dataSourceExport" class="drag-list mat-elevation-z8" style="margin-top: 40px;margin-left: 4px;">
    <ng-container matColumnDef="order">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; "> Order </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; ">
            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                <mat-icon color="primary" matTooltip="Re-order column"  style="cursor: grab" cdkDrag [cdkDragData]="exportcolumninfo"
                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
            </div>
        </td>
    </ng-container>
    <!-- <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; ">
           index
        </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; "> 
            {{def.index}}
        </td>
    </ng-container> -->
    <ng-container matColumnDef="include">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; ">
            <mat-slide-toggle  color="primary" (change)="onExportIncludeChanged($event)" [(ngModel)]="isSelectAll"></mat-slide-toggle>
        </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; "> 
            <mat-slide-toggle color="primary" [checked]="def.isinclude" [disabled]="isPartitionSelected(def.name)" (change)="def.isinclude = $event.checked"></mat-slide-toggle>
        </td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 150px;margin-left: 3px; margin-right: 3px; "> Source Column </th>
        <td mat-cell *matCellDef="let def" style="width: 150px;"> {{def.name}} </td>
    </ng-container>
    <ng-container matColumnDef="entertargetcolumn">
        <th mat-header-cell *matHeaderCellDef style="width: 200px;margin-left: 3px; margin-right: 3px; "> 
            <mat-slide-toggle  color="primary" (change)="onUseSourceChanged($event)" [(ngModel)]="isUseSource">Use Source </mat-slide-toggle><br>
            Enter Target Column
        </th>
        <td mat-cell *matCellDef="let def;let i = index" style="width: 150px;"> 
            <input matInput #targetInput placeholder="Enter Target Column" type="text" [(ngModel)]="def.targetcolumn" [disabled]="isUseSource" [ngClass]="{'disabled-input': isUseSource}"
            (keydown.enter)="handleMoveToField('forward', i, $event)"
            (keydown.shift.enter)="handleMoveToField('reverse', i, $event)"
            (keydown.tab)="handleMoveToField('forward', i, $event)"
            (keydown.shift.tab)="handleMoveToField('reverse', i, $event)">
        </td>
    </ng-container>
    <ng-container matColumnDef="dataType">
        <th mat-header-cell *matHeaderCellDef style="width: 80px;margin-left: 3px; margin-right: 3px; "> Data Type </th>
        <td mat-cell *matCellDef="let def" style="width: 80px;margin-left: 3px; margin-right: 3px; "> {{def.dataType}} </td>
    </ng-container>
    <ng-container matColumnDef="targetcolumn">
        <th mat-header-cell *matHeaderCellDef style="width: 200px;margin-left: 3px; margin-right: 3px; "> Target Column </th>
        <td mat-cell *matCellDef="let def;let i = index" style="width: 150px;"> 
    <!--app-autocomplete-field [(ngModel)]="def.targetcolumn">
            <mat-option></mat-option>
            <mat-option *ngFor="let col of targetcolumns" [value]="col.value">{{col.text}}
            </mat-option>
        </mat-select>-->
      <app-autocomplete-field 
        [options]="options" 
        [disabledColumns]="disabledColumns"
        [placeholder]="defaultTargetColumn" 
        [(ngModel)]="def.targetcolumn"
        (selectionChange)="onTargetColumnChanged(def, $event)"
        (moveToNextField)="handleMoveToFieldOld($event, i)"
        ></app-autocomplete-field>
      
      
        </td>
    </ng-container>
    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Description </th>
        <td style="width: auto; margin-left: 3px; margin-right: 3px; color: gray" mat-cell *matCellDef="let def"> {{def.description}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsExport"></tr>
    <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumnsExport;"></tr>
    <div *cdkDragPlaceholder></div>
</table>
</div>